import { HiddenAssetSource, HiddenRecord } from '../../types';
import { callExternalApi, CallResult } from '../callExternalApi';

const HIDDEN_ASSETS_BASE_URL = 'api/hidden_assets';

interface HiddenAssetPayload {
  asset_id: string;
  account_id: string;
  source?: HiddenAssetSource;
}

export async function createHiddenAsset(payload: HiddenAssetPayload): Promise<CallResult<unknown>> {
  return await callExternalApi<unknown>({
    url: HIDDEN_ASSETS_BASE_URL,
    method: 'POST',
    data: payload,
    headers: {
      'content-type': 'application/json'
    }
  });
}

export async function deleteHiddenAsset(
  assetId: string,
  accountId: string,
  source?: HiddenAssetSource
): Promise<CallResult<unknown>> {
  const sourceParam = source ? `&source=${source}` : '';
  return await callExternalApi<unknown>({
    url: `${HIDDEN_ASSETS_BASE_URL}/${assetId}?account_id=${accountId}${sourceParam}`,
    method: 'DELETE',
    headers: {
      'content-type': 'application/json'
    }
  });
}

export async function fetchHiddenAssets(accountId?: string): Promise<CallResult<HiddenRecord[]>> {
  if (!accountId) return { data: null, error: { message: 'Must provide a single account ID to fetch hidden assets' } };

  return await callExternalApi<HiddenRecord[]>({
    url: `${HIDDEN_ASSETS_BASE_URL}?account_id=${accountId}`,
    method: 'GET',
    headers: {
      'content-type': 'application/json'
    }
  });
}
